export default __webpack_public_path__ + "static/media/bematech.afc67447.png";